import { z } from 'zod';
import { CompatibilityAspect } from './compatibility';
import { PublicPersonalityCodeDto } from './personality-code';

export const CompatibilityPersonDto = z.object({
  userId: z.uuid(),
  displayName: z.string(),
  username: z.string().nullable(),
  photoUrl: z.string().nullable(),
  personalityCode: PublicPersonalityCodeDto.nullable(),
  viewedAt: z.iso.datetime().nullable(),
  matchedAt: z.iso.datetime(),
});
export type CompatibilityPersonDto = z.infer<typeof CompatibilityPersonDto>;

export const CompatibilityPeopleDto = z.object({
  people: z.array(CompatibilityPersonDto),
});
export type CompatibilityPeopleDto = z.infer<typeof CompatibilityPeopleDto>;

export const CompatibilitySharedEventDto = z.object({
  id: z.uuid(),
  title: z.string(),
  startsAt: z.iso.datetime(),
  placeName: z.string().nullable(),
});
export type CompatibilitySharedEventDto = z.infer<typeof CompatibilitySharedEventDto>;

/** Явка второго человека на будущей встрече: приглашение ещё открыто или уже принято. */
export const CompatibilityPeerAttendanceStatus = z.enum(['INVITED', 'CONFIRMED']);
export type CompatibilityPeerAttendanceStatus = z.infer<typeof CompatibilityPeerAttendanceStatus>;

export const CompatibilityUpcomingEventDto = CompatibilitySharedEventDto.extend({
  peerStatus: CompatibilityPeerAttendanceStatus,
});
export type CompatibilityUpcomingEventDto = z.infer<typeof CompatibilityUpcomingEventDto>;

export const SavedCompatibilityAspectDto = z.object({
  aspect: CompatibilityAspect,
  text: z.string(),
});
export type SavedCompatibilityAspectDto = z.infer<typeof SavedCompatibilityAspectDto>;

/** Уже оплаченный разбор пары. Нет строки в кэше — null, новый LLM-запрос не стартует. */
export const SavedCompatibilityDto = z.object({
  mainText: z.string(),
  aspects: z.array(SavedCompatibilityAspectDto),
});
export type SavedCompatibilityDto = z.infer<typeof SavedCompatibilityDto>;

export const CompatibilityPersonDetailDto = CompatibilityPersonDto.extend({
  sharedInterests: z.array(z.string()),
  sharedEvents: z.array(CompatibilitySharedEventDto),
  upcomingEvents: z.array(CompatibilityUpcomingEventDto),
  savedAnalysis: SavedCompatibilityDto.nullable(),
  /** Есть взаимный матч: только он открывает чат и приглашение на встречу с этого экрана. */
  hasMatch: z.boolean(),
});
export type CompatibilityPersonDetailDto = z.infer<typeof CompatibilityPersonDetailDto>;

export const CompatibilityViewsDto = z.object({ userIds: z.array(z.uuid()) });
export type CompatibilityViewsDto = z.infer<typeof CompatibilityViewsDto>;
